/**
 * 全局存储用户假消息
 */
import utils from './utils';

import config from './config';

import platform from '../utils/platform';

const isEmpty = utils.isEmpty;

const sumBigNumber = utils.sumBigNumber;

const strToNumCompare = utils.strToNumCompare;

const queque = utils.queque;

const falseMsgs = queque(10);

let false_msgs_queue;

const existFalseMsgs = {};

const falseLastMsgs = {};

var isSupportedAudio = false;

(function () {
  if (platform.isIos) {
    if (platform.ios_version && (platform.isSafari && parseFloat(platform.ios_version) >= 11)) {
      isSupportedAudio = true;
    }
  } else if (platform.isAndriod && platform.isWeixin) {
      isSupportedAudio = true;
  }
})();

let saveExistFalseMsgs = (msg, tmpKey) => {
  if (`${msg.msg_id}` !== '' && !isEmpty(msg.msg_id) && !isEmpty(tmpKey)) {
    if (isEmpty(existFalseMsgs[tmpKey])) {
      existFalseMsgs[tmpKey] = {};
    }
    if (!isEmpty(existFalseMsgs[tmpKey][msg.msg_id])) {
      return
    }
    existFalseMsgs[tmpKey][msg.msg_id] = msg;
    if (!isEmpty(msg.follow_msg_id) && !isEmpty(existFalseMsgs[tmpKey][msg.follow_msg_id])) {
      let follow_msg = existFalseMsgs[tmpKey][msg.follow_msg_id];
      follow_msg.fellow_id = msg.msg_id;
    }
  }
};

function falseMsgCut(deleted, lasted) {
  if (deleted && lasted && deleted.length && lasted.length) {
    var firstMsg = lasted[0];
    var changed = false;
    var originalMsgId = null;
    if (firstMsg.follow_msg_id) {
      originalMsgId = firstMsg.msg_id;
      for(var index=deleted.length-1;index>=0;index--) {
        if (deleted[index].belong_to !== firstMsg.belong_to) {
          continue;
        }
        if (deleted[index].tmpKey !== firstMsg.tmpKey) {
          continue;
        }
        if (deleted[index].msg_id === firstMsg.follow_msg_id) {
          firstMsg.follow_msg_id = deleted[index].follow_msg_id;
          firstMsg.msg_id = deleted[index].msg_id;
          changed = true;
        }
      }
      if (changed && originalMsgId) {
        for(var index=1;index<lasted.length;index++) {
          if (lasted[0].belong_to === lasted[index].belong_to && lasted[0].tmpKey === lasted[index].tmpKey && lasted[index].follow_msg_id === originalMsgId) {
            lasted[index].follow_msg_id = lasted[0].msg_id;
            break;
          }
        }
      }
    }
  }
};

function dicInit() {
  try {
    false_msgs_queue = window.localStorage.getItem('false_msgs_queue') || '{}';
    false_msgs_queue = JSON.parse(false_msgs_queue);
    false_msgs_queue = false_msgs_queue.msgs || [];
  }catch(e){
      false_msgs_queue = [];
  }

  falseMsgs.push(false_msgs_queue, falseMsgCut);

  var _falseMsgs = falseMsgs.pull();

  for(var index=0; index < _falseMsgs.length; index++) {
    var falseNew = _falseMsgs[index];
    if (falseNew.tmpKey) {
      saveExistFalseMsgs(falseNew, falseNew.tmpKey);
      if (isEmpty(falseLastMsgs[falseNew.belong_to])) {
        falseLastMsgs[falseNew.belong_to] = {};
      }
      falseLastMsgs[falseNew.belong_to][falseNew.tmpKey] = falseNew;
    }
  }
}

let gatherExistFalseMsgs = (tmpKey, msg_id, userKey) => {
  let false_news = [];
  if (!isEmpty(msg_id) && !isEmpty(tmpKey)) {
    msg_id = sumBigNumber(msg_id, '1');
    if (!isEmpty(existFalseMsgs[tmpKey])) {
      while (!isEmpty(existFalseMsgs[tmpKey][msg_id]) && existFalseMsgs[tmpKey][msg_id].belong_to === userKey) {
        false_news.push(existFalseMsgs[tmpKey][msg_id]);
        if (!isEmpty(existFalseMsgs[tmpKey][msg_id].fellow_id)) {
          var fellow_id = existFalseMsgs[tmpKey][msg_id].fellow_id;
          if (fellow_id == msg_id) {
            break;
          } else {
            msg_id = fellow_id;
          }
        } else {
          break;
        }
      }
    }
  }
  return false_news;
}

let userKey = ''

var isInited = false;

function init() {
  if (!(window.wbWebRTCSDK && window.wbWebRTCSDK.isSupport)) {
    return;
  }
  if (!isSupportedAudio) {
    return;
  }
  if (!(config && config.get('is_show_audio_video'))) {
    return;
  }
  if (isInited) return;
  dicInit();
  isInited = true;
}

export default {
  get: function () {
    !isInited && init();
    return falseMsgs.pull();
  },
  set: function (msgs) {
    !isInited && init();
    if (msgs instanceof Array && msgs.length) {
      falseMsgs.push(msgs, falseMsgCut);
    } else {
      return
    }
    try {
        window.localStorage.setItem('false_msgs_queue', JSON.stringify({
            msgs: falseMsgs.pull()
        }));
    }catch(e){

    }
  },
  setUser: function (user_id, user_source) {
    userKey = user_id + '@' + user_source;
  },
  getFalseLastMsg: function (tmpKey) {
    !isInited && init();
    return falseLastMsgs[userKey] ? falseLastMsgs[userKey][tmpKey] : null
  },
  setFalseLastMsg: function (tmpKey, falseMsg) {
    !isInited && init();
    if (isEmpty(userKey)) return;
    if (isEmpty(falseLastMsgs[userKey])) {
      falseLastMsgs[userKey] = {}
    }
    if (!isEmpty(falseLastMsgs[userKey][tmpKey]) && strToNumCompare(falseLastMsgs[userKey][tmpKey].msg_id, falseMsg.msg_id) >= 0) {
      return;
    }
    falseLastMsgs[userKey][tmpKey] = falseMsg
  },
  getExistFalseMsg: function (tmpKey, msgId) {
    !isInited && init();
    if (existFalseMsgs[tmpKey] && msgId && userKey) {
      let _msgId = sumBigNumber(msgId, '1');
      let msg = existFalseMsgs[tmpKey][_msgId];
      if (msg && msg.belong_to === userKey) {
        return msg
      }
    }
    return null;
  },
  saveExistFalseMsgs: function () {
    !isInited && init();
    return saveExistFalseMsgs.apply(this, arguments);
  },
  gatherExistFalseMsgs: function () {
    !isInited && init();
    return gatherExistFalseMsgs.apply(this, arguments);
  }
};